import { Button } from "react-migration/components/DeprecatedButton";
import classNames from "clsx";

type SwitchButtonSize = "small" | "large";

interface SwitchButtonsProps {
  size?: SwitchButtonSize;
  labelPrefix?: string;
  currentIndex: number;
  totalCount: number;
  onPreviousBtnClick: () => void;
  onNextBtnClick: () => void;
}

const ActionButton = ({
  icon,
  size,
  onClick,
  disabled,
}: {
  icon: string;
  size: SwitchButtonSize | undefined;
  onClick: () => void;
  disabled?: boolean;
}) => {
  return (
    <Button.Secondary
      size={size || "large"}
      className={classNames(`w-${size && size === "small" ? 8 : 10}`)}
      onClick={onClick}
      disabled={disabled}
    >
      <i
        className={classNames(
          `icon-lt-arrow-${icon}-s-line`,
          "flex",
          "items-center",
          `text-${size && size === "small" ? "lg" : "2xl"}`,
          "text-text-base-primary"
        )}
      />
    </Button.Secondary>
  );
};

export const SwitchButtons = ({
  size,
  labelPrefix = "",
  currentIndex,
  totalCount,
  onPreviousBtnClick,
  onNextBtnClick,
}: SwitchButtonsProps) => {
  const labelText = `${labelPrefix} ${currentIndex + 1} of ${totalCount}`.trim();

  return (
    <div className="flex gap-x-2" data-testid="switch-buttons-wrapper">
      <ActionButton icon="left" size={size} onClick={onPreviousBtnClick} disabled={currentIndex === 0} />
      <span
        className={classNames(
          "flex",
          "whitespace-nowrap",
          "items-center",
          "font-semibold",
          "text-xs",
          "leading-3",
          "text-text-base-secondary"
        )}
      >
        {labelText}
      </span>
      <ActionButton icon="right" size={size} onClick={onNextBtnClick} disabled={currentIndex === totalCount - 1} />
    </div>
  );
};
